import type { TowerDesign } from "@/game/towerSpec";
/**
 * Bozrah 187 ft guyed tower (Polly Ln, Bozrah CT), from reference_towers/
 * 02_engineering_drawings/CT_Bozrah_PollyLn_guyed_187ft_structural.pdf.
 * EXACT: 187 ft (57.0 m), 3x (triangular) guyed, face width 3.50 ft top & base
 * (constant) → circumradius 0.616 m. TIA-222-G, 105 mph, 0.75" ice.
 * Guy attach heights not cleanly tabulated → standard 4-level spacing (flagged).
 */
export const design: TowerDesign = {
  id: "guyed-bozrah-187ft",
  name: "Guyed Tower (Bozrah 187 ft)",
  description: "Real 187 ft triangular guyed tower, Bozrah CT (TIA-222-G, 105 mph).",
  author: "reference: CT Bozrah Polly Ln 187 ft SA",
  spec: {
    type: "guyed",
    height: 57.0,
    stack: { faces: 3, panels: 38, baseRadius: 0.616, topRadius: 0.616,
      legSection: "legXL", braceSection: "angleL5", legMaterial: "a572", braceMaterial: "a572", bracing: "X" },
    guys: [0.28, 0.5, 0.72, 0.94].map((f, i) => ({ atHeightFrac: f, anchorRadius: 22 + i * 8, section: "guy38", material: "guyStrand", pretensionStrain: 0.001 })),
    foundation: { soil: "stiff-clay", base: { type: "pier", width: 0.6, diameter: 0.6, depth: 1.5, concrete: "c20" }, anchor: { type: "deadman", width: 1.5, diameter: 0.6, depth: 2, concrete: "c20" } },
  },
};
